enum AreaContextType {
	DEFAULT,
	MANAGE,
	LOGIN,
}

export default AreaContextType;
